import { computed } from 'vue';
import { useStore } from 'vuex';
import { getAccountPlaceTypes } from '@gpx-spa/queries';
import {
  placeTypeLabel,
  placeTypeOptions,
  placeTypeParents,
} from '@/config/geofenceTaxonomy';

export function usePlaceTypes() {
  const store = useStore();
  const accountId = computed(() => store.getters['auth/accountId']);
  const { data, isLoading } = getAccountPlaceTypes(accountId);

  const placeTypes = computed(() => data.value ?? []);

  return {
    placeTypes,
    isLoading,
    options: computed(() => placeTypeOptions(placeTypes.value)),
    parents: computed(() => placeTypeParents(placeTypes.value)),
    labelFor: (slug) => placeTypeLabel(placeTypes.value, slug),
  };
}
